import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";
import { CaseEvent } from "./events";

export enum FinalFICDecision {
  FRAUD = "FRAUD",
  NO_FRAUD = "NO_FRAUD",
  ATTEMPTED_FRAUD = "ATTEMPTED_FRAUD",
}

export const FinalFICDecisionLabels: Record<FinalFICDecision, string> = {
  [FinalFICDecision.FRAUD]: "Fraud",
  [FinalFICDecision.NO_FRAUD]: "No Fraud",
  [FinalFICDecision.ATTEMPTED_FRAUD]: "Attempted Fraud",
};

export interface FinalFICReport {
  convener?: string;
  name_of_committee?: string;
  members_of_committee?: string[];
  committee_decision?: FinalFICDecision;
  review_committee_remarks?: string;
  fraud_classification?: string;
}

export interface AddFinalFICMeetingRequest {
  convener: string;
  name_of_committee: string;
  members_of_committee: string[];
  committee_decision: FinalFICDecision;
  fraud_classification: string;
  date_of_committee: string;
  review_committee_remarks?: string;
  exposure?: number;
  events?: CaseEvent[];
}

export interface UpdateFinalFICMeetingRequest {
  convener?: string;
  name_of_committee?: string;
  members_of_committee?: string[];
  committee_decision?: FinalFICDecision;
  fraud_classification?: string;
  review_committee_remarks?: string;
  exposure?: number;
  events?: CaseEvent[];
}

export interface FinalFICMeetingResponse {
  report?: FinalFICReport;
}

export interface SaveFinalFICMeetingResponse {
  report?: FinalFICReport;
  events?: CaseEvent[];
}

export interface SimpleMessageResponse {
  message: string;
}

export const FinalFICAPI = {
  getFinalFIC: async (
    caseId: string
  ): Promise<FinalFICMeetingResponse> => {
    const response: AxiosResponse<FinalFICMeetingResponse> =
      await axiosInstance.get(`v1/cases/${caseId}/final-fic-meeting`);

    return response.data;
  },

  createFinalFIC: async (
    caseId: string,
    request: AddFinalFICMeetingRequest
  ): Promise<SaveFinalFICMeetingResponse> => {
    const response: AxiosResponse<SaveFinalFICMeetingResponse> =
      await axiosInstance.post(
        `v1/cases/${caseId}/final-fic-meeting`,
        request
      );

    return response.data;
  },

  updateFinalFIC: async (
    caseId: string,
    request: UpdateFinalFICMeetingRequest
  ): Promise<SimpleMessageResponse> => {
    const response: AxiosResponse<SimpleMessageResponse> =
      await axiosInstance.patch(
        `v1/cases/${caseId}/final-fic-meeting`,
        request
      );

    return response.data;
  },
};